import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/media';

export default function NewsPanel({ items }: { items: NewsItem[] }) {
  const [headline, ...rest] = items;
  if (!headline) return null;

  return (
    <div className="flex flex-col">
      <Link to={`/detail/${headline.relatedId}`} className="group block relative rounded-lg overflow-hidden">
        <div className="w-full h-[180px] md:h-[210px] overflow-hidden bg-background-200">
          <img
            src={headline.cover}
            alt={headline.title}
            title={`${headline.title} - 蘑菇视频资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/30 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-4">
          <span className="inline-block px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium mb-2">
            {headline.category}
          </span>
          <h3 className="text-base md:text-lg font-bold text-background-50 leading-snug line-clamp-2 group-hover:text-primary-300 transition-colors">
            {headline.title}
          </h3>
        </div>
      </Link>

      <ul className="mt-2 divide-y divide-background-200">
        {rest.map((news) => (
          <li key={news.id}>
            <Link
              to={`/detail/${news.relatedId}`}
              className="group flex items-start gap-3 py-3.5 hover:bg-background-100/60 px-2 rounded-md transition-colors"
            >
              <span className="mt-0.5 w-1.5 h-1.5 rounded-full bg-primary-400 shrink-0"></span>
              <span className="flex flex-col gap-1 min-w-0">
                <span className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {news.title}
                </span>
                <span className="flex items-center gap-2 text-xs text-foreground-400">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{news.category}</span>
                  <span>{news.date}</span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}